/* eslint-disable @typescript-eslint/no-unused-vars */
import { memo, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';

const styles = () => {
  return createStyles({
    root: {},
  });
};

export interface IDeleteAndRevokeModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose?: any;
  onClickActionButton?: any;
  typeWord?: string;
  modalTitle?: string;
  modalDescription?: string;
  actinButtonLabel?: string;
}

const DeleteConfirmationModal = ({
  open,
  handleClose,
  onClickActionButton,
  typeWord,
  modalTitle,
  modalDescription,
}: IDeleteAndRevokeModalProps) => {
  const [confirmationWord, setConfirmationWord] = useState('');
  const [isActionConfirm, setIsActionConfirm] = useState(false);
  const intl = useIntl();

  const confirmationWordOnChange = (e: { target: { value: string } }) => {
    setConfirmationWord(e.target.value);
  };

  useEffect(() => {
    if (confirmationWord === typeWord) {
      setIsActionConfirm(true);
      return;
    }
    setIsActionConfirm(false);
  }, [confirmationWord]);

  return (
    <ActionModal
      modalTitle={modalTitle}
      modalDescription={modalDescription}
      id="delete-confirmation-modal"
      open={open}
      handleClose={handleClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'remove',
      })}
    />
  );
};

export default memo(withStyles(styles)(DeleteConfirmationModal));
